import constant from "../constant";

const MARPOL_HISTORY_BY_MODULE = {
  orb2: constant.Authedcomponent.marpolOrbPart2History?.url,
  grb: constant.Authedcomponent.marpolGarbageHistory?.url,
  bwr: constant.Authedcomponent.marpolBallastHistory?.url,
  brb: constant.Authedcomponent.marpolBiofoulingHistory?.url,
  "annex-iv": constant.Authedcomponent.marpolAnnexIVHistory?.url,
  "annex-vi": constant.Authedcomponent.marpolAnnexVIHistory?.url,
};

/**
 * Resolve in-app navigation path for a notification row.
 */
export function notificationLink(item) {
  if (!item) return constant.Authedcomponent.notificationsCenter.url;

  switch (item.link_type) {
    case "deck_log":
      return constant.Authedcomponent.deckLogList?.url || "/report/deck-log/list";
    case "engine_log":
      return constant.Authedcomponent.noonReportList?.url || "/report/engine-log/list";
    case "orb_approvals":
      return constant.Authedcomponent.marpolOrbPart1Approvals?.url;
    case "marpol_history":
      return (
        MARPOL_HISTORY_BY_MODULE[item.marpol_module] ||
        constant.Authedcomponent.marpolOrbPart1History?.url
      );
    default:
      return constant.Authedcomponent.adminActivityLog?.url;
  }
}

export function formatTimeAgo(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";

  const seconds = Math.floor((Date.now() - d.getTime()) / 1000);
  if (seconds < 60) return "just now";
  if (seconds < 3600) {
    const mins = Math.floor(seconds / 60);
    return `${mins} min${mins === 1 ? "" : "s"} ago`;
  }
  if (seconds < 86400) {
    const hours = Math.floor(seconds / 3600);
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  }
  const days = Math.floor(seconds / 86400);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}

export function formatWhen(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export const categoryLabel = (category) => {
  switch (category) {
    case "approval":
      return "Approval";
    case "audit":
      return "Compliance";
    case "activity":
      return "Activity";
    default:
      return "Notification";
  }
};

export const categoryBadgeClass = (category) => {
  switch (category) {
    case "approval":
      return "bg-warning text-dark";
    case "audit":
      return "bg-light text-dark border";
    case "activity":
      return "bg-primary text-white";
    default:
      return "bg-secondary text-white";
  }
};
